import { render, staticRenderFns } from "./form-leg.vue?vue&type=template&id=a04b32e4&"
import script from "./form-leg.vue?vue&type=script&lang=js&"
export * from "./form-leg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "form-leg.vue"
export default component.exports